module.exports = __webpack_public_path__ + "static/img/悬浮冶金.18b6dbd.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/悬浮冶金.jpg
// module id = DbGS
// module chunks = 1